import { Box, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

export interface ContentWarningProps {
  color?: string;
}

const ContentWarning: React.FC<ContentWarningProps> = ({
  children,
  color = 'green',
}) => {
  const styles = useStyleConfig('ContentWarning', { color });
  return <Box __css={styles}>{children}</Box>;
};

export default ContentWarning;
